<template>
  <div class="history-track">
    <div class="fields" style="display: flex">
      <!-- 原有的时间选择表单 -->
      <el-form
        :model="form"
        ref="form"
        label-width="120px"
        style="display: flex"
      >
        <el-form-item label="时间">
          <el-date-picker
            v-model="form.variableDate"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="history-btns" style="margin-left: 100px">
        <el-button
          @click="queryGps()"
          style="border: 1px solid #00cc00; color: #00cc00"
          >查询</el-button
        >
        <el-button
          @click="backPage()"
          style="border: 1px solid #00cc00; color: #00cc00; margin-left: 30px"
          >返回</el-button
        >
        <el-button @click="resetForm()" style="margin-left: 30px"
          >重置</el-button
        >
      </div>
    </div>

    <div id="map" class="map-wrapper">
      <!-- 添加图例 -->
      <div class="map-legend">
        <div class="legend-item">
          <div class="color-dot start-dot"></div>
          <span>起点</span>
        </div>
        <div class="legend-item">
          <div class="color-dot end-dot"></div>
          <span>终点</span>
        </div>
        <div class="legend-item">
          <div class="color-line"></div>
          <span>轨迹路线</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GpsConverter from "@/utils/gpsConverter";

export default {
  name: "HistoryTrack",
  data() {
    return {
      form: { variableDate: [] },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近5分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 300 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近10分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 600 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 1800 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近1小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近6小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近12小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 12);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      map: null,
      polyline: null,
      markers: []
    };
  },
  mounted() {
    // 延迟初始化，确保 DOM 完全渲染
    setTimeout(() => {
      this.initMap();
    }, 300);
  },
  methods: {
    // 初始化地图 - 简化版本，不添加控件
    initMap() {
      // 直接创建地图，不添加额外控件
      this.map = new AMap.Map("map", {
        zoom: 13,
        center: [116.397428, 39.90923], // 默认中心点
        viewMode: "2D"
      });

      console.log("地图初始化完成");
    },

    // 如果需要添加控件，使用异步加载方式
    initMapWithControls() {
      AMap.plugin(["AMap.ToolBar", "AMap.Scale"], () => {
        // 创建地图实例
        this.map = new AMap.Map("map", {
          zoom: 13,
          center: [116.397428, 39.90923]
        });

        // 添加工具条控件
        const toolBar = new AMap.ToolBar();
        this.map.addControl(toolBar);

        // 添加比例尺控件
        const scale = new AMap.Scale();
        this.map.addControl(scale);
      });
    },

    // 绘制轨迹
    // 绘制轨迹
    drawTrack(pathData) {
      if (!this.map) {
        console.error("地图未初始化");
        return;
      }

      // 清除之前的轨迹和标记
      this.clearTrack();

      if (!pathData || pathData.length === 0) {
        this.$message.warning("没有轨迹数据可显示");
        return;
      }

      // 创建轨迹线 - 添加方向箭头
      this.polyline = new AMap.Polyline({
        path: pathData,
        strokeColor: "#3366FF",
        strokeWeight: 10, // 注意：showDir 在线宽大于6时效果更好 [citation:3]
        strokeStyle: "solid",
        strokeOpacity: 0.8,
        // 只保留这两个核心属性试试
        showDir: true,
        dirColor: "#FFFFFF"
        // 移除 dirImg、dirArrowSize、dirArrowStyle，让地图用默认参数渲染
      });

      // 将轨迹线添加到地图
      this.map.add(this.polyline);

      // 添加起点和终点标记
      this.addTrackMarkers(pathData);

      // 调整地图视野到轨迹范围
      this.map.setFitView(this.polyline);
    },

    // 添加轨迹标记点
    addTrackMarkers(pathData) {
      if (pathData.length > 0) {
        // 起点标记
        const startMarker = new AMap.Marker({
          position: pathData[0],
          content:
            '<div style="background: #00cc00; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>',
          offset: new AMap.Pixel(-6, -6)
        });
        this.map.add(startMarker);
        this.markers.push(startMarker);
      }

      if (pathData.length > 1) {
        // 终点标记
        const endMarker = new AMap.Marker({
          position: pathData[pathData.length - 1],
          content:
            '<div style="background: #ff0000; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>',
          offset: new AMap.Pixel(-6, -6)
        });
        this.map.add(endMarker);
        this.markers.push(endMarker);
      }
    },

    // 清除轨迹
    clearTrack() {
      if (this.polyline) {
        this.map.remove(this.polyline);
        this.polyline = null;
      }

      // 清除所有标记
      this.markers.forEach(marker => {
        this.map.remove(marker);
      });
      this.markers = [];
    },

    backPage() {
      this.$router.go(-1);
    },

    resetForm() {
      this.form.variableDate = [];
      this.clearTrack();
      // 重置地图视图
      if (this.map) {
        this.map.setZoomAndCenter(13, [116.397428, 39.90923]);
      }
    },

    queryGps() {
      if (!this.form.variableDate || this.form.variableDate.length === 0) {
        this.$message.warning("请选择查询时间范围");
        return;
      }

      const date1 = new Date(this.form.variableDate[0]);
      const date2 = new Date(this.form.variableDate[1]);
      const diffTime = Math.abs(date2 - date1);

      if (diffTime > 3600 * 1000 * 24 * 3) {
        this.$message.warning("查询时间请不要超过3天！");
        return;
      }

      const tmpParamDate = this.form.variableDate.join(",");

      this.$store.dispatch("form/handle", {
        url: "/battery/dcDevice/historyGps",
        data: {
          deviceId: this.$route.query.data,
          queryTime: tmpParamDate
        },
        method: "get",
        callback: resp => {
          console.log("轨迹数据:", resp);

          if (resp && resp.path) {
            // 使用工具类批量转换坐标（后台返回的是WGS-84，需要转GCJ-02）
            const convertedPath = GpsConverter.batchWgs84ToGcj02(resp.path);

            // 绘制轨迹
            this.drawTrack(convertedPath);
            //this.$message.success("轨迹加载成功");
          } else {
            this.$message.warning("未获取到轨迹数据");
          }
        }
      });
    }
  },
  beforeDestroy() {
    // 组件销毁时清理地图
    if (this.map) {
      this.map.destroy();
    }
  }
};
</script>

<style lang="less" scoped>
.history-track {
  padding: 20px;
}

.fields {
  margin-bottom: 20px;
  align-items: center;
}

.map-wrapper {
  height: 600px;
  width: 100%;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  position: relative;
}

// 图例样式
.map-legend {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-size: 12px;

  .legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .color-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid white;
    margin-right: 8px;
  }

  .start-dot {
    background: #00cc00; // 绿色起点
  }

  .end-dot {
    background: #ff0000; // 红色终点
  }

  .color-line {
    width: 20px;
    height: 4px;
    background: #3366ff; // 蓝色轨迹线
    margin-right: 8px;
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/historyDataOther.vue